import { IconName, IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import Site from 'es/app/business-logic/domain-models/Site';
import { AccessControlCollection, ChallengeType } from 'es/app/security/IAccessControlSet';
import useAccessControlAuthorization from 'es/app/security/protected/AccessControlAuthorization';
import { observer } from 'mobx-react';
import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './NavDrawerLink.module.css';

export interface INavDrawerLink {
    text: string;
    icon: IconProp | ReactNode;
    route: string;
    accessControls?: string | AccessControlCollection;
    site?: Site;
    className?: string;
}

export const NavDrawerLink = observer(({ text, icon, route, accessControls, site, className }: INavDrawerLink) => {
    const permitted = useAccessControlAuthorization(accessControls, site, ChallengeType.All);
    const classNames = cn(className, styles.navDrawerLink);

    if (!permitted) return null;

    return (
        <NavLink className={classNames} to={route}>
            <div className={styles.navDrawerLinkIconWrapper}>
                {React.isValidElement(icon) && icon}
                {!React.isValidElement(icon) && !!icon && <FontAwesomeIcon icon={icon as IconName} />}
            </div>
            <span className={styles.navDrawerLinkText}>{text}</span>
        </NavLink>
    );
});
